// Room
//
//  desc:
//         
//
//
//  props:
//


import React, { Component } from 'react';

import WALL_0000 from '../../../../resources/images/walls/wall_0000.png';
import WALL_0001 from '../../../../resources/images/walls/wall_0001.png';
import WALL_0010 from '../../../../resources/images/walls/wall_0010.png';
import WALL_0011 from '../../../../resources/images/walls/wall_0011.png';
import WALL_0100 from '../../../../resources/images/walls/wall_0100.png';
import WALL_0101 from '../../../../resources/images/walls/wall_0101.png';
import WALL_0110 from '../../../../resources/images/walls/wall_0110.png';
import WALL_0111 from '../../../../resources/images/walls/wall_0111.png';
import WALL_1000 from '../../../../resources/images/walls/wall_1000.png';
import WALL_1001 from '../../../../resources/images/walls/wall_1001.png';
import WALL_1010 from '../../../../resources/images/walls/wall_1010.png';
import WALL_1011 from '../../../../resources/images/walls/wall_1011.png';
import WALL_1100 from '../../../../resources/images/walls/wall_1100.png';
import WALL_1101 from '../../../../resources/images/walls/wall_1101.png';
import WALL_1110 from '../../../../resources/images/walls/wall_1110.png';
import WALL_1111 from '../../../../resources/images/walls/wall_1111.png';

class Room extends Component
{
    constructor(props)
  {
    super(props);


  }


  chooseImage(roomShape)
  {
    var retImage = "";
    switch (roomShape)
    {
      case '0000':
      {
        retImage = WALL_0000;
        break;
      }
      case '0001':
      {
        retImage = WALL_0001;
        break;
      }
      case '0010':
      {
        retImage = WALL_0010;
        break
      }
      case '0011':
      {
        retImage = WALL_0011;
        break;
      }
      case '0100':
      {
        retImage = WALL_0100;
        break;
      }
      case '0101':
      {
        retImage = WALL_0101;
        break;
      }
      case '0110':
      {
        retImage = WALL_0110;
        break;
      }
      case '0111':
      {
        retImage = WALL_0111;
        break;
      }
      case '1000':
      {
        retImage = WALL_1000;
        break;
      }
      case '1001':
      {
        retImage = WALL_1001;
        break;
      }
      case '1010':
      {
        retImage = WALL_1010;
        break;
      }
      case '1011':
      {
        retImage = WALL_1011;
        break;
      }
      case '1100':
      {
        retImage = WALL_1100;
        break;
      }
      case '1101':
      {
        retImage = WALL_1101;
        break;
      }
      case '1110':
      {
        retImage = WALL_1110;
        break;
      }
      case '1111':
      {
        retImage = WALL_1111;
        break;
      }
      default:
      {
        retImage = WALL_0001;
        break;
      }
    }
    
    return retImage;
  }

   render()
   { 

      var displayImage = this.chooseImage(this.props.room.getRoomType());
    
      return(
       <div id={this.props.id} className={this.props.extraClasses} > 
         <img src={displayImage} alt="maze room"/> 
       </div>
      );
   }
}

export default Room; //export the room component
